var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2908.25 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-5{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#91b3fa;}.cls-5{mix-blend-mode:soft-light;}.cls-6{fill:#bdd0fb;}.cls-7{fill:#2b69b3;}.cls-8{fill:#18174a;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{opacity:0.86;}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3130.27,
    y1: 2837.89,
    x2: 1047.94,
    y2: 1015.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1659.76,
    y1: 962.03,
    x2: 430.55,
    y2: 872.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 681.79,
    y1: 2113.71,
    x2: 1811.19,
    y2: 1446.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2744.41,
    y1: 1196.5,
    x2: 1320.84,
    y2: 2194.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1378.52,
    y1: 967.53,
    x2: 2665.52,
    y2: 851.97,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1672.79,
    y1: 1318.63,
    x2: 706.23,
    y2: 2206.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2824.43,
    y1: 196.55,
    x2: 1442.88,
    y2: 1410,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1086.05,
    y1: 1973.23,
    x2: 1238.68,
    y2: 2320.48,
    gradientTransform: "translate(373.4 -208.14) rotate(-12.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2281.67,
    y1: 2800.85,
    x2: 2526.83,
    y2: 2457.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1513.96,
    y1: 2937.22,
    x2: 1614.77,
    y2: 1758.98,
    gradientTransform: "translate(536.97)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2144.42,
    y1: 2549.39,
    x2: 1997.33,
    y2: 2834.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1716.75,
    y1: 2954.75,
    x2: 1817.59,
    y2: 1776.2,
    gradientTransform: "translate(536.97)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2418.99,
    y1: 1136.53,
    x2: 2198.37,
    y2: 1514.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1502.9,
    y1: 1775.83,
    x2: 1521.84,
    y2: 1637.29,
    gradientTransform: "translate(536.97)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1580.95,
    y1: 1843.34,
    x2: 1706.75,
    y2: 1843.34,
    gradientTransform: "translate(536.97)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1238,
    y1: 2074.98,
    x2: 1403.23,
    y2: 1780.92,
    gradientTransform: "translate(388.63 -185.82) rotate(-11.2)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1273.17,
    y1: 2094.75,
    x2: 1438.4,
    y2: 1800.69,
    gradientTransform: "translate(388.63 -185.82) rotate(-11.2)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1055.89,
    y1: 1986.49,
    x2: 1208.52,
    y2: 2333.74,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3192.84,
    y1: 1399.4,
    x2: -3151.74,
    y2: 1399.4,
    gradientTransform: "matrix(-1, 0, 0, 1, -1430.21, 0)",
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -400.88,
    y: -455,
    width: 3710,
    height: 3710
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2776.38,1891.62c-269.12,633.68-986,988.67-1607.67,892.91-101.16-15.58-378.5-62-624-281C72,2082-29.09,1247.34,352.21,659.11,629.72,231,1127.2-11.71,1599.9.43c101.82,2.62,492,18.73,835,301.51,50.37,41.53,161.46,140.23,261.59,296.8C2931.57,966.41,2951.77,1478.65,2776.38,1891.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.35,71.31c-4.63-14.46,12.26-26.27,24.4-17.14C404,146.84,707,431.62,700.36,988.12,692,1686.34,863.15,1922,1058.64,2055.74c0,0-253.27-45.18-435.64-283.35C175.26,1187.63,338.58,328.51,256.35,71.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365,277.18c22.4,75.17,43.31,150.74,61.42,227Q454.19,618.33,474.9,734c13.48,77.09,25.52,154.42,34.25,232.14,9.08,77.68,14.82,155.66,20.3,234,5.92,78.24,11.43,157.09,25,235.62,13.51,78.38,36.59,156.4,73.24,227.89,9.15,17.82,18.67,35.54,29.13,52.52,10.16,17.18,21.08,33.92,32.29,50.45a854.59,854.59,0,0,0,74.47,94c54.26,59,117.45,109.58,185.47,150.84a15.16,15.16,0,0,0,16.11-25.69l-.05,0c-16.26-10.5-32.38-21.18-48-32.54-7.88-5.55-15.51-11.45-23.24-17.2-7.5-6-15.24-11.77-22.55-18a799,799,0,0,1-83.34-79.64c-51.81-56.72-95.4-121.48-130.54-189.71a764.45,764.45,0,0,1-43.65-106.4,866.73,866.73,0,0,1-27.74-112.12c-13.79-76.16-19.9-154.16-26.38-232.35S546,1041,535.63,962.83Q528,904.22,518.3,845.93c-3.13-19.44-6.63-38.82-10.1-58.2q-5.47-29-11.33-58-23.72-115.71-54.51-229.71c-20.92-75.84-43.84-151.11-69.62-225.36a4.07,4.07,0,0,0-7.74,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.57,1808.05c-8.15,21-35.14,26.94-51.52,11.41-90.38-85.7-324-351.11-291.16-779.8,27.71-362,8.34-560.95-6.71-650.65C12,370,34.88,358,48.7,371.4,201.24,518.91,659.71,1045.24,364.57,1808.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M334,1807.56a8.67,8.67,0,0,1-1.52.77,8.81,8.81,0,0,1-11.41-5c-2-5.15-200-519.93-184.19-1025a8.81,8.81,0,0,1,17.62.55c-15.69,501.42,181,1013,183,1018.08A8.81,8.81,0,0,1,334,1807.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.12,2512.58a45.73,45.73,0,0,0,45.61,45.58h2466.8a45.73,45.73,0,0,0,45.61-45.58L2778.67,1095c0-25.07-29.53-74-83.65-70.33L284.2,962.28a115,115,0,0,0-118,117.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.15,2468.86A43.28,43.28,0,0,0,288.31,2512H2653a43.28,43.28,0,0,0,43.15-43.16L2715.56,1182c-2.28-77.44-70.17-105.27-111.33-103.63l-2310.55-62A80.78,80.78,0,0,0,210.79,1099Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2670.64,1857.49h-.09a6.31,6.31,0,0,1-6.23-6.42l1.53-104.37a6.32,6.32,0,0,1,6.32-6.23h.06a6.33,6.33,0,0,1,6.26,6.42L2677,1851.26A6.32,6.32,0,0,1,2670.64,1857.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2674.4,1601.74h-.1a6.33,6.33,0,0,1-6.23-6.42l5.87-399.73c-.11-23.74-7.32-42.7-21.42-56.21-26.33-25.23-68.14-23.94-69.9-23.86l-738.5-19.8a6.33,6.33,0,0,1-6.16-6.49,6.06,6.06,0,0,1,6.5-6.15l738.06,19.8c4.59-.27,49.1-1,78.75,27.36,16.67,16,25.19,38,25.32,65.42l-5.87,399.85A6.33,6.33,0,0,1,2674.4,1601.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 2551.28,
    width: 2908.25,
    height: 124.55,
    rx: 5.65,
    transform: "translate(2908.25 5227.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1439.07,424.24c-532.35,16.51-960.54,434.54-975.65,953.31-.34,11.41,9.07,20.86,20.79,20.89l929.23,3.08c32,.11,58-25.32,57.61-56.5l-9.91-900.17C1461,433.18,1451.05,423.87,1439.07,424.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M470.61,1450.93a7.56,7.56,0,0,0-7.66,7.45v0c0,542.51,446.64,982.28,997.6,982.28h.1a10.34,10.34,0,0,0,10.43-10.38l-10-919.94c-.34-31.14-26-56.23-57.64-56.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1498.05,1491.49l10.21,928.26c.13,11.54,10,20.75,21.82,20.39,541.16-16.63,974.76-448.71,975.8-979.77l-2.85-2.79-967.16-3.21C1514.84,1454.3,1497.82,1471,1498.05,1491.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2443.8,1404.93a35.37,35.37,0,0,0,35.48-36.67c-19.79-525-451.66-944.6-981.54-944.6h0a10.46,10.46,0,0,0-10.46,10.58l10,928.86a39.15,39.15,0,0,0,39,38.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1439.94,428.77C921.62,445.29,504.71,863.31,490,1382.08a20.34,20.34,0,0,0,20.25,20.9l904.75,3.07a55.9,55.9,0,0,0,56.09-56.5l-9.65-900.17A20.84,20.84,0,0,0,1439.94,428.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M497.07,1455.47a7.49,7.49,0,0,0-7.55,7.44v.07c0,542.49,439.77,982.26,982.26,982.26h.1a10.26,10.26,0,0,0,10.27-10.38l-9.86-919.94a56.93,56.93,0,0,0-56.74-56.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1524.62,1496l10,928.26a20.63,20.63,0,0,0,21.26,20.39C2083.09,2428,2505.56,1996,2506.57,1464.9l-2.78-2.79-942.32-3.21A36.73,36.73,0,0,0,1524.62,1496Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2470.37,1409.46a35.39,35.39,0,0,0,35.49-36.67c-19.8-525-451.67-944.6-981.55-944.6h0a10.46,10.46,0,0,0-10.46,10.58l10,928.87a39.16,39.16,0,0,0,39,38.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1715.35,994.14c0-109,88.68-197.67,197.67-197.67s197.68,88.67,197.68,197.67S2022,1191.81,1913,1191.81,1715.35,1103.14,1715.35,994.14Zm12.19,0c0,102.28,83.21,185.49,185.48,185.49s185.49-83.21,185.49-185.49S2015.3,808.65,1913,808.65,1727.54,891.86,1727.54,994.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1972.65,963.69h19.55c2.45,0,4.39-3.53,4.39-6V944.38c0-24.92-20.22-43.55-45.14-43.55h-25.58V881.08c0-4.11-5.62-7.45-11.79-7.45s-11.78,3.34-11.78,7.45v19.75h-25c-24.92,0-45.74,18.63-45.74,43.55v24.37c0,24.92,20.82,46,45.74,46h25v47.14h-25c-9.24,0-18.24-8.77-18.24-18v-1.14c0-2.46-.51-4.42-3-4.42h-19.55c-2.46,0-5,2-5,4.42v1.14c0,24.92,20.82,41.59,45.74,41.59h25v21.71c0,4.11,5.61,7.45,11.78,7.45s11.79-3.34,11.79-7.45v-21.71h25.58c24.92,0,45.14-16.67,45.14-41.59v-13.2c0-24.92-20.22-47.36-45.14-47.36h-25.58V924.41h25.58c9.24,0,17.64,10.73,17.64,20v13.33C1969.09,960.16,1970.19,963.69,1972.65,963.69Zm-21.2,51.08c9.24,0,17.64,6.69,17.64,15.93v13.2c0,9.24-8.4,18-17.64,18h-25.58v-47.14Zm-49.15-31.43h-25c-9.24,0-18.24-5.35-18.24-14.59V944.38c0-9.24,9-20,18.24-20h25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1269.44,977.85a11.64,11.64,0,0,1-8.15,5.55l-24.22,3.93a137.37,137.37,0,0,1-18.41,29.12l6.83,23.57a11.7,11.7,0,0,1-4.49,12.8l-29,20.43a11.7,11.7,0,0,1-13.57-.07l-19.91-14.35a137.81,137.81,0,0,1-33.61,7.59l-11.82,21.48a11.77,11.77,0,0,1-12.23,5.89l-34.92-6a11.68,11.68,0,0,1-9.55-9.65l-3.93-24.2a137.59,137.59,0,0,1-29.11-18.42l-23.57,6.84a11.71,11.71,0,0,1-12.81-4.49l-20.42-29a11.6,11.6,0,0,1,.08-13.58L981,975.39a137.61,137.61,0,0,1-7.58-33.6L951.94,930a11.7,11.7,0,0,1-5.88-12.24l6-34.91a11.68,11.68,0,0,1,9.67-9.54L986,869.34a137,137,0,0,1,18.41-29.12l-6.83-23.57a11.68,11.68,0,0,1,4.49-12.8l29-20.43a11.7,11.7,0,0,1,13.57.07l19.91,14.35a137.81,137.81,0,0,1,33.61-7.59l11.82-21.49a11.74,11.74,0,0,1,12.24-5.87l34.91,6a11.68,11.68,0,0,1,9.55,9.66l3.93,24.19a137.59,137.59,0,0,1,29.11,18.42l23.57-6.84a11.7,11.7,0,0,1,12.8,4.48l20.43,29a11.72,11.72,0,0,1-.05,13.55L1242,881.28a137.72,137.72,0,0,1,7.58,33.6l21.49,11.83a11.69,11.69,0,0,1,5.88,12.2l-6,34.94A11.81,11.81,0,0,1,1269.44,977.85Zm-45.31-7.18,29.38-4.77,4.37-25.31-26.08-14.35-.3-5.11a119.34,119.34,0,0,0-8.51-37.74l-1.92-4.74,17.41-24.16-14.81-21-28.6,8.29-3.82-3.39a119.34,119.34,0,0,0-32.7-20.69l-4.71-2-4.77-29.38L1123.76,782,1109.41,808l-5.1.3a119.23,119.23,0,0,0-37.74,8.52l-4.74,1.92-24.16-17.41-21,14.8,8.3,28.61-3.4,3.82a118.73,118.73,0,0,0-20.68,32.69l-2,4.71-29.38,4.77-4.37,25.32,26.08,14.34.3,5.11a119,119,0,0,0,8.52,37.74L1002,978l-17.41,24.16,14.81,21,28.6-8.29,3.82,3.39a119.34,119.34,0,0,0,32.7,20.69l4.7,2,4.78,29.38,25.31,4.37,14.35-26.07,5.1-.3a119.23,119.23,0,0,0,37.74-8.52l4.74-1.92,24.16,17.41,21-14.81-8.29-28.6,3.39-3.82a119,119,0,0,0,20.69-32.7ZM1096.91,1079l0,0Zm51.38-297.43v0Zm-22.18-3.83ZM981.69,1006.13l0,0Zm33.63-194.65v0S1015.31,811.49,1015.32,811.48Zm-50.61,80.07h0Zm227.59,85.94a94.79,94.79,0,1,1-65.24-142,95.45,95.45,0,0,1,19.4,5.51,9.26,9.26,0,1,1-6.93,17.18,76.35,76.35,0,0,0-72.54,8.39,76.23,76.23,0,1,0,115.09,34.87,9.26,9.26,0,1,1,17.28-6.68,95.15,95.15,0,0,1-7.06,82.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1146.48,949.17a40.72,40.72,0,1,1-38.07-61.44h0a40.7,40.7,0,0,1,38.07,61.44ZM1092.42,917a22.22,22.22,0,1,0,17.4-10.78h0a22,22,0,0,0-15.16,7.68A23,23,0,0,0,1092.42,917Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M977.57,1153.34c-.17.27-.35.53-.55.79l-10.49,13.47a8.1,8.1,0,0,1-9,2.69l-9.94-3.4a68.5,68.5,0,0,1-12.66,7.19l-2.17,10.27a8.12,8.12,0,0,1-6.94,6.38l-16.91,2.1a8.09,8.09,0,0,1-8.29-4.49l-4.61-9.42a68.63,68.63,0,0,1-14-3.87l-8.8,5.73a8.1,8.1,0,0,1-9.41-.4l-13.45-10.47a8.12,8.12,0,0,1-2.69-9l3.4-10a68.82,68.82,0,0,1-7.19-12.66l-10.28-2.17a8.11,8.11,0,0,1-6.36-6.93l-2.11-16.92a8.12,8.12,0,0,1,4.54-8.31l9.37-4.6a68.39,68.39,0,0,1,3.88-14l-5.74-8.81a8.19,8.19,0,0,1,.42-9.43L848,1053.66a8.14,8.14,0,0,1,9-2.7l9.94,3.41a68.87,68.87,0,0,1,12.66-7.2l2.17-10.27a8.13,8.13,0,0,1,6.9-6.37l17-2.1a8.11,8.11,0,0,1,8.29,4.49l4.62,9.41a68.39,68.39,0,0,1,14,3.88l8.81-5.73a8.13,8.13,0,0,1,9.41.4l13.45,10.47a8.12,8.12,0,0,1,2.69,9l-3.4,10a68.82,68.82,0,0,1,7.19,12.66l10.27,2.17a8.13,8.13,0,0,1,6.37,6.92l2.1,16.93a8.11,8.11,0,0,1-4.48,8.29l-9.42,4.62a68.56,68.56,0,0,1-3.88,14l5.73,8.8A8.16,8.16,0,0,1,977.57,1153.34Zm-11.81-1h0Zm-7.66,3.49,5.41-6.94-7.59-11.67,1.6-3.48a55,55,0,0,0,4.74-17.16l.41-3.81,12.49-6.13-1.09-8.73L960.46,1095l-1.33-3.6a54.93,54.93,0,0,0-8.79-15.47l-2.41-3,4.51-13.17-7-5.41-11.67,7.6-3.48-1.61a55,55,0,0,0-17.16-4.74l-3.81-.4-6.12-12.5-8.74,1.09-2.88,13.61-3.59,1.33a54.85,54.85,0,0,0-15.48,8.79l-3,2.41-13.17-4.51-5.41,7,7.59,11.67-1.61,3.48a54.85,54.85,0,0,0-4.73,17.16l-.41,3.81-12.49,6.13,1.08,8.73,13.61,2.88,1.33,3.59a54.91,54.91,0,0,0,8.8,15.48l2.41,3-4.51,13.17,6.94,5.41,11.67-7.6,3.48,1.61a54.8,54.8,0,0,0,17.16,4.73l3.81.41,6.13,12.49,8.73-1.08,2.88-13.61,3.6-1.33a54.91,54.91,0,0,0,15.48-8.8l3-2.4Zm-2.55,3.28,0,0Zm-36.41,22.38v0Zm-6.08.75h0Zm-5.93-3.18h0Zm-41.59-9.89,0,0ZM901.43,1039v0Zm-12.86-.68,0,0Zm-52.92,78.11.08,0Zm12.81-40.81s0,0,0,0Zm99.91,59.87a48.3,48.3,0,0,1-3.39,5,48.07,48.07,0,1,1-43.86-77.24,48.65,48.65,0,0,1,10.23-.18,6.95,6.95,0,0,1-1.23,13.84,34.16,34.16,0,1,0,23.88,13,6.95,6.95,0,0,1,11-8.56,48.1,48.1,0,0,1,3.42,54.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M788.17,1855.54c0-109,88.67-197.67,197.67-197.67s197.67,88.67,197.67,197.67-88.68,197.67-197.67,197.67S788.17,1964.53,788.17,1855.54Zm12.18,0c0,102.27,83.21,185.48,185.49,185.48s185.48-83.21,185.48-185.48-83.21-185.49-185.48-185.49S800.35,1753.26,800.35,1855.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1042.51,1783.39c0,29.21-23.68,60.75-52.89,60.75s-52.89-31.54-52.89-60.75,23.68-49.93,52.89-49.93S1042.51,1754.18,1042.51,1783.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M924,1956.6H1053.1a31.26,31.26,0,0,0,29.77-21.73l6.94-21.71a31.22,31.22,0,0,0-18.86-38.85c-52.54-19.21-106.88-16.75-162.54,1.77a31.13,31.13,0,0,0-19.94,37.73l5.35,19.72A31.24,31.24,0,0,0,924,1956.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1854.28,1929.7l-87.81-1.89V1804.08a7.31,7.31,0,0,1,7.58-7.3l74.89,2.77a5.55,5.55,0,0,1,5.34,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1975,1932.21l-87.81-1.78V1743.55a5.73,5.73,0,0,1,6-5.72l76.64,3.26a5.44,5.44,0,0,1,5.2,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2092.1,1934.76,2008,1933V1696.2a7.71,7.71,0,0,1,8.11-7.71l69.8,3.54a6.58,6.58,0,0,1,6.24,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2102.94,1989l-351.08-5.1a3.73,3.73,0,0,1-3.68-3.74v-22a3.74,3.74,0,0,1,3.8-3.74l351.08,6.31a3.72,3.72,0,0,1,3.67,3.73v20.86A3.72,3.72,0,0,1,2102.94,1989Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M973.29,2487.51a15.68,15.68,0,0,1-3.32-.35C833.62,2458,691.32,2369,569.28,2236.58,446.53,2103.37,360,1942.77,325.53,1784.38a15.76,15.76,0,0,1,30.8-6.7c33.26,153,117.12,308.39,236.14,437.54,117.65,127.67,254.06,213.3,384.1,241.12a15.76,15.76,0,0,1-3.28,31.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.87,1923.86a16.64,16.64,0,0,1-2.87-.26,15.76,15.76,0,0,1-12.64-18.36l30.72-166.51a15.76,15.76,0,0,1,29.59-4.19,243.63,243.63,0,0,0,82.67,94.15,15.76,15.76,0,1,1-17.62,26.13,274.67,274.67,0,0,1-71.21-69.35L318.36,1911A15.78,15.78,0,0,1,302.87,1923.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2493,758.44a15.75,15.75,0,0,1-13.76-8.07c-76.49-136.61-202.08-260.73-353.63-349.49-149.81-87.74-305.26-129.77-437.77-118.42a15.76,15.76,0,0,1-2.7-31.4c138.89-12,301,31.61,456.4,122.63,156.32,91.55,286,219.85,365.2,361.28A15.78,15.78,0,0,1,2493,758.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2511.51,794a15.77,15.77,0,0,1-11.43-4.9,243.71,243.71,0,0,0-106.56-65.9,15.75,15.75,0,1,1,9.22-30.13,275,275,0,0,1,88.36,45.53l-14.5-126.78a15.76,15.76,0,1,1,31.31-3.58l19.25,168.21A15.76,15.76,0,0,1,2511.51,794Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2093.93,1445.7s27.85,13.55,33,29.11c4.11,12.49,34.9,14.1,37.95,38.66a28.18,28.18,0,0,0,23.58,24.77c31.45,4.82,79.92,21.15,87.68,75.76,5.92,41.68-15.33,57.49-37.63,63-16.38,4-27.26,20-23.95,36.48,3.18,15.87-1.56,34.2-29,48.7-61.58,32.49-123.07-77-123.07-77L2049.82,1494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1758.88,1400.39s122.94,194.46,269.14,232c0,0-28.49,81.14-50.48,90.43,0,0-179.86-150.08-226.08-294.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2347,2644.17l4,32.75a13.53,13.53,0,0,0,11.87,11.84c10.5,1.2,27.35,2.43,43.84.69a11.59,11.59,0,0,0,9.73-15c-4-12.64-11.37-31.63-22-42.8h-36.34A11.2,11.2,0,0,0,2347,2644.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2062.42,2260.45l-6.13,36.08s20.54,208,24.19,291.25a65.2,65.2,0,0,1-9.65,37.06l-35.71,58,90.76-53.55,1.81-11.08-14.86-20.43,19.46-233.06a71.45,71.45,0,0,0-8.13-39.54l-18.78-35.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2029.14,2691.24h29a17.44,17.44,0,0,0,13.84-6.79c9-11.73,27.73-34.62,36.68-35.22,12-.81,10.5,42,10.5,42h6.75l8.55-53.2a31.49,31.49,0,0,0-16.52-32.92s-2.75,20.36-17.68,29.36-60.74,41.26-60.74,41.26a41.44,41.44,0,0,0-11.77.31C2018.58,2677.7,2019.85,2691.24,2029.14,2691.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2186.74,2277.58s120.32,228.24,139.45,280.35,25.83,95.58,26.08,99.7c.4,6.43,8.4,12.6,30.46,12.6,11.38,0,16.95-4.56,19.68-9a12.85,12.85,0,0,0,.49-12.45c-7-14.08-29.05-59.1-37.23-79.51-9.77-24.38-30.78-134.85-42.3-173.26s-24.54-80.07-74.72-118.45C2248.65,2277.58,2214.21,2243.85,2186.74,2277.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2110.73,1903.6c-31-131.52,47.59-205.9,47.59-205.9-49.61-47.62-140-69.29-140-69.29s-86.26,63.06-76,112.42c6,28.92,60.63,173.27,60.63,173.27S2053.44,1938,2110.73,1903.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2179.55,1968.71c-12.64-38-68.82-65.11-68.82-65.11-57.29,34.41-107.81,10.5-107.81,10.5s-11.33,43.31-3.51,83.55,56.88,298.88,56.88,298.88c77.3,15.66,196.18-15.76,196.18-15.76C2203.24,2193.35,2192.18,2006.77,2179.55,1968.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2074.7,1541.5l25.24,113.34c2.41,10-6.69,8.35-16.78,6.45-16.53-3.12-37.84-9.54-45-22.4a12.23,12.23,0,0,1-1.29-4.27l-10.84-78.6a14.13,14.13,0,0,1,8.26-14.84l20.92-9.27A14.12,14.12,0,0,1,2074.7,1541.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2158.32,1697.7s176.12,126,22.53,258.41c0,0-5.86,6.63-17.38,10.07-5.82,1.74-23,14.76-31.75,21.55a6,6,0,0,1-8.74-1.58,8.15,8.15,0,0,1-.46-7.82l21.8-46.11a16.82,16.82,0,0,1,21.84-1,8.3,8.3,0,0,0,12.59-2.84c11.87-24.19,34.29-95.31-57.48-175.68a9.94,9.94,0,0,1-2.2-12.09C2125.52,1728.28,2140.26,1703.68,2158.32,1697.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2026.37,1438.17s-26.86,18.18-38.41,64.49,7.22,62.93,26.45,61.91,47.11-7,71.27-40.19S2061.57,1416,2026.37,1438.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2061.32,1505.7s9.84-66.36-45.26-56.21l-11.14,11.6s-27-30.37,2.88-53.33,71.26-17.07,94.17,24.72,31.23,71.16,12,97.13-33.65,3.7-33.65,3.7,8.81-22.48,1.5-32.12-16.73,5.6-16.73,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2068.85,1511.38s4.86-34.14,22.29-24.38-6.28,31.9-15.79,39.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1759.73,1440.43c-.38,4,14.54,6.78,19.29-10.32-1.31-7.43-3.63-39.94-9.32-45-30.32-26.9-84.38-57.16-84.38-57.16-6,9.23,1.88,15.31,1.88,15.31l27,18.21c-2.82,9.33-6.92,17.57-7.39,28.22a31.58,31.58,0,0,0,8,22.06c5.37,6.14,12.6,14.06,19.12,20.08C1746.23,1443.23,1759.73,1440.43,1759.73,1440.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1745.07,1427.17l4.12-1.69c-.55-1.34-13.5-32.81-19.76-39.36-2.38-2.48-3.53-4.61-3.43-6.32a4.55,4.55,0,0,1,1.39-2.78l21.84,11.68,9.64,15.1,3.76-2.4-10.27-16.09-25.58-13.68-1.15.94c-2.59,2.12-3.93,4.39-4.08,7-.19,3.06,1.33,6.22,4.65,9.69C1730.92,1394.14,1741.42,1418.28,1745.07,1427.17Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmImg3);
export default __webpack_public_path__ + "static/media/crm_img_3.2b9ccd0b3339821532a7c53b4bf15ad2.svg";
export { ForwardRef as ReactComponent };